import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { Skeleton } from './Skeleton';

export type StandaloneSkeletonProps = StandaloneComponentProps<typeof Skeleton>;

export const StandaloneSkeleton: StandaloneComponent<StandaloneSkeletonProps> = (props) => {
  return <Skeleton {...props} />;
};
